/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const NvCameraResponseNotification: BridgeCommands.Command<
    {},
    Types.Common.Nvcamera.NvCameraResponseNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'NvCameraResponseNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const NvCameraFilterResponseNotification: BridgeCommands.Command<
    {},
    Types.Common.Nvcamera.NvCameraFilterResponseNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'NvCameraFilterResponseNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const NvCameraUIControlNotificationData: BridgeCommands.Command<
    {},
    Types.Common.Nvcamera.NvCameraUIControlNotificationDataReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'NvCameraUIControlNotificationData',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const NgxAIUpResNotifications: BridgeCommands.Command<
    {},
    Types.Common.Nvcamera.NgxAIUpResNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'NgxAIUpResNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetAnselEnable: BridgeCommands.Command<
    Types.Common.Nvcamera.SetAnselEnableParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'SetAnselEnable',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetFeatureSet: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'GetFeatureSet',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetProcessInfo: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'GetProcessInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetNvCameraConfig: BridgeCommands.Command<
    {},
    Types.Common.Nvcamera.GetNvCameraConfigReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'GetNvCameraConfig',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetVersion: BridgeCommands.Command<
    {},
    Types.Common.Nvcamera.GetVersionReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'GetVersion',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const AnselUIReady: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'AnselUIReady',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAnselCaptureTypes: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'GetAnselCaptureTypes',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAnselEnabledStatus: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'GetAnselEnabledStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetLanguage: BridgeCommands.Command<
    Types.Common.Nvcamera.SetLanguageParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'SetLanguage',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetNvCameraConfig: BridgeCommands.Command<
    Types.Common.Nvcamera.SetNvCameraConfigParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'SetNvCameraConfig',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CaptureScreenshot: BridgeCommands.Command<
    Types.Common.Nvcamera.CaptureScreenshotParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'CaptureScreenshot',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetCaptureResolutions: BridgeCommands.Command<
    Types.Common.Nvcamera.GetCaptureResolutionsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'GetCaptureResolutions',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetFilter: BridgeCommands.Command<
    Types.Common.Nvcamera.SetFilterParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'SetFilter',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetCurrentFilterInfo: BridgeCommands.Command<
    Types.Common.Nvcamera.GetCurrentFilterInfoParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'GetCurrentFilterInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ResetFilter: BridgeCommands.Command<
    Types.Common.Nvcamera.ResetFilterParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'ResetFilter',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const InsertFilter: BridgeCommands.Command<
    Types.Common.Nvcamera.InsertFilterParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'InsertFilter',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RemoveFilter: BridgeCommands.Command<
    Types.Common.Nvcamera.RemoveFilterParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'RemoveFilter',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const MoveFilter: BridgeCommands.Command<
    Types.Common.Nvcamera.MoveFilterParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'MoveFilter',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetFilterStackInfo: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'GetFilterStackInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ResetFilterStack: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'ResetFilterStack',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetFilterAttribute: BridgeCommands.Command<
    Types.Common.Nvcamera.SetFilterAttributeParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'SetFilterAttribute',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetFilterAndAttributes: BridgeCommands.Command<
    Types.Common.Nvcamera.SetFilterAndAttributesParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'SetFilterAndAttributes',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CancelCapture: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'CancelCapture',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetCameraControlFovRoll: BridgeCommands.Command<
    Types.Common.Nvcamera.SetCameraControlFovRollParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'SetCameraControlFovRoll',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetCameraControlFov: BridgeCommands.Command<
    Types.Common.Nvcamera.GetCameraControlFovParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'GetCameraControlFov',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetCameraRangeFovRoll: BridgeCommands.Command<
    Types.Common.Nvcamera.GetCameraRangeFovRollParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'GetCameraRangeFovRoll',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetCameraGridOfThirds: BridgeCommands.Command<
    Types.Common.Nvcamera.SetCameraGridOfThirdsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'SetCameraGridOfThirds',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetAnselRedirection: BridgeCommands.Command<
    Types.Common.Nvcamera.AnselRedirectionParams,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'SetAnselRedirection',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SendEnableRedirectionToSP: BridgeCommands.Command<
    Types.Common.Nvcamera.AnselRedirectionParams,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'SendEnableRedirectionToSP',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const MouseEventToNvcamera: BridgeCommands.Command<
    Types.Common.Nvcamera.MouseEventToNvcameraParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'MouseEventToNvcamera',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const KeyboardEventToNvcamera: BridgeCommands.Command<
    Types.Common.Nvcamera.KeyboardEventToNvcameraParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'KeyboardEventToNvcamera',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetFreestyleWhitelisted: BridgeCommands.Command<
    Types.Common.Nvcamera.GetFreestyleWhitelistedParameters,
    Types.Common.Nvcamera.GetFreestyleWhitelistedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'GetFreestyleWhitelisted',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetNvCameraOnBusStatus: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'GetNvCameraOnBusStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StartNgxAIUpRes: BridgeCommands.Command<
    Types.Common.Nvcamera.StartNgxAIUpResParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'StartNgxAIUpRes',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CancelNgxAIUpRes: BridgeCommands.Command<
    Types.Common.Nvcamera.CancelNgxAIUpResParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'CancelNgxAIUpRes',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const AnselShotSavedNotification: BridgeCommands.Command<
    Types.Common.Nvcamera.AnselShotSavedNotificationParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'AnselShotSavedNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetCMSInfo: BridgeCommands.Command<
    Types.Common.Nvcamera.SetCMSInfoParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'SetCMSInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetLcarsClientId: BridgeCommands.Command<
    Types.Common.Nvcamera.SetLcarsClientIdParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'SetLcarsClientId',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ChromaDataNotification: BridgeCommands.Command<
    {},
    Types.Common.Nvcamera.ChromaDataNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCamera',
    method: 'ChromaDataNotification',
    persistent: true
};

export const Nvcamera = {
NvCameraResponseNotification,
NvCameraFilterResponseNotification,
NvCameraUIControlNotificationData,
NgxAIUpResNotifications,
SetAnselEnable,
GetFeatureSet,
GetProcessInfo,
GetNvCameraConfig,
GetVersion,
AnselUIReady,
GetAnselCaptureTypes,
GetAnselEnabledStatus,
SetLanguage,
SetNvCameraConfig,
CaptureScreenshot,
GetCaptureResolutions,
SetFilter,
GetCurrentFilterInfo,
ResetFilter,
InsertFilter,
RemoveFilter,
MoveFilter,
GetFilterStackInfo,
ResetFilterStack,
SetFilterAttribute,
SetFilterAndAttributes,
CancelCapture,
SetCameraControlFovRoll,
GetCameraControlFov,
GetCameraRangeFovRoll,
SetCameraGridOfThirds,
SetAnselRedirection,
SendEnableRedirectionToSP,
MouseEventToNvcamera,
KeyboardEventToNvcamera,
GetFreestyleWhitelisted,
GetNvCameraOnBusStatus,
StartNgxAIUpRes,
CancelNgxAIUpRes,
AnselShotSavedNotification,
SetCMSInfo,
SetLcarsClientId,
ChromaDataNotification
};
